import { useCallback, useMemo } from 'react';
import {
  makeWorkFromWorkPocoV4,
  useFlowAndLayouts,
  useOfflineWorkCreationOperations,
  WellKnownFlowFeaturesEnum,
} from '@diana/core';

export const useWorkboardCreateWorkOffline = (props: { flowId: string }) => {
  const { flowId } = props;

  const offlineWorkCreationOperations = useOfflineWorkCreationOperations();

  const { fetchedFlow, fetchedLayouts, layouts } = useFlowAndLayouts({
    flowId,
    flowQueryOptions: { enabled: false }, // we interested in cached flow only
    layoutQueryOptions: { enabled: false }, // we interested in cached layouts only
  });

  const areLayoutsReady = useMemo(() => fetchedLayouts.every(Boolean), [fetchedLayouts]);

  const canCreateWorkOffline = useMemo(() => {
    const featureFlags = fetchedFlow?.properties.featureFlags;
    const hasFeatureFlag = featureFlags?.[WellKnownFlowFeaturesEnum.IsOfflineModeEnabled];
    return hasFeatureFlag && areLayoutsReady;
  }, [areLayoutsReady, fetchedFlow?.properties.featureFlags]);

  const createWorkOffline = useCallback(
    async (stepName: string) => {
      if (!fetchedFlow) {
        throw new Error('Flow not found');
      }
      const work = offlineWorkCreationOperations.startWork(fetchedFlow, stepName);
      return makeWorkFromWorkPocoV4({ flow: fetchedFlow, work, workData: {}, layouts });
    },
    [fetchedFlow, offlineWorkCreationOperations, layouts],
  );

  return { fetchedFlow, canCreateWorkOffline, createWorkOffline };
};
